import React, { useEffect, useState } from "react";
import "./ECLObjectInstanceBlock.css";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";
import { ECLUnsafeStringifyULID } from "../../../../utilities/ECLUUID";
import * as arrow from "apache-arrow";
import { ECLLoader } from "../../../index";
import endpointRequest from "../../../../utilities/requests/endpointRequest";

/**
 * ECLObjectInstanceBlock returns a UI with all non-hidden values from a row with field labels
 * @param {object} props -
 * @param {string} props.seanQLQuery - string for the seanQL query
 * @param  {Array<string>} props.hiddenFields - array with strings of fields to hide
 * @returns {ReactNode} A React element that renders labels and values for first row of query.
 */

export default function ECLObjectInstanceBlock(props) {
   //this only returns the first row
   const [labels, setLabels] = useState([]);
   const [firstRowValues, setFirstRowValues] = useState([]);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);
   const selectorId = useSelectorId();

   useEffect(() => {
      const rootID = props.headlist.at(-1); //Last item on the headlist is your root
      const sessionID = props.flatDoc[rootID].session;
      endpointRequest(props.parentObject, props.block.id, sessionID, "AllData")
         .then((results) => {
            //If no results, just set row values to an empty array
            if (results.rows.length === 0) {
               setFirstRowValues([]);
            } else {
               const labels = [];
               const shownFieldIndicies = [];
               const hiddenFields = props.block.data.columns
                  .filter((obj) => !obj.shown)
                  .map((obj) => obj.columnName);
               results.columns.map((field, i) => {
                  if (!hiddenFields.includes(field.name)) {
                     labels.push(field.name);
                     shownFieldIndicies.push(i);
                  }
               });
               setLabels(labels);
               //set types for columns
               const valueTypes = results.columns.map(
                  (field) => field.type.typeId,
               );
               //set first row display values depending on types in columns
               const firstRowValues = [];

               if (results.rows.length > 0) {
                  results.rows[0].map((value, i) => {
                     if (shownFieldIndicies.includes(i)) {
                        if (valueTypes[i] === arrow.Type.FixedSizeBinary) {
                           firstRowValues.push(ECLUnsafeStringifyULID(value));
                        } else {
                           firstRowValues.push(value);
                        }
                     }
                  });
                  setFirstRowValues(firstRowValues);
               }
            }
            setLoading(false);
         })
         .catch((error) => {
            console.error(`error: ${error}`);
            setError("Error loading Object Instance");
         });
   }, [props.block.react.refresh]);

   if (loading || error) {
      return <ECLLoader message={error} />;
   }

   if (firstRowValues.length === 0) {
      return (
         <div>
            <label htmlFor={`object-instance-block${selectorId}`}>
               {props.block.data.name}
            </label>
            <div
               className="ecl-object-instance-block"
               id={`object-instance-block${selectorId}`}
            >
               <p
                  style={{
                     fontWeight: "bold",
                     width: "100%",
                     textAlign: "center",
                  }}
               >
                  No instance to display
               </p>
            </div>
         </div>
      );
   }

   return (
      <div>
         <label htmlFor={`object-instance-block${selectorId}`}>
            {props.block.data.name}
         </label>
         <div
            className="ecl-object-instance-block"
            id={`object-instance-block${selectorId}`}
         >
            {labels.map((label, i) => {
               return (
                  <div key={`${selectorId}-${i}`} className="label-value-block">
                     <label htmlFor={`value-block-${selectorId}-${i}`}>
                        {label}
                     </label>
                     <p id={`value-block-${selectorId}-${i}`}>
                        {String(firstRowValues[i])}
                     </p>
                  </div>
               );
            })}
         </div>
      </div>
   );
}
